import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { URLs } from '../../Constants/Consts'
import { blobToBase64, fetchApi } from '../../Helpers/Functions'
import { addUrls } from '../../store/Drawings'
import { updateDownloadTriggered, updateHasDownloadedValue } from '../../store/Utilities'
import { RootState } from '../../store/store'
import { FileDrawingType } from '../../types/types'

export default function storeDrawings() {
    const [isloading, setIsloading] = React.useState(false)
    const dispatch = useDispatch()
    const { SelectedUser } = useSelector(
        (state: RootState) => state.SelectedUser
    );
    const { downloadTriggered: { drawings: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    React.useEffect(() => {
        if (navigator.onLine && SelectedUser.jwt && SelectedUser.projectNumber && (triggered)) {
            (async () => {
                calledOnceRef.current = true
                setIsloading(true)
                try {
                    const drawings = await fetchApi(
                        URLs.getDrawingsUrl(SelectedUser.projectNumber))
                        .then(res => res.json()) as FileDrawingType[]
                    
                    // Filter to only load drawings where load_for_project is true or undefined (backward compatibility)
                    const drawingsToLoad = drawings.filter(drawing => drawing.loadForProject !== false);
                    
                    const objectUrls = await Promise.all(await drawingsToLoad.map(async (drawing) => {
                        const { drawingDisplayName, drawingFilename, drawingUuid, projectNumber } = drawing
                        return (await fetchApi(URLs.getFileBlobUrl2(Number(projectNumber), String(drawingFilename)))
                        ).blob()
                            .then(blobToBase64).then(async data => {
                                const blobObject = await fetch(data)
                                    .then(response => response.blob())
                                return { data: data, url: window.URL.createObjectURL(blobObject), label: String(drawingDisplayName), id: String(drawingUuid) }
                            }
                            )
                    }))
                    // update store
                    dispatch(addUrls(objectUrls))
                    dispatch(updateHasDownloadedValue({ key: "drawings", value: true }))
                    dispatch(updateDownloadTriggered({ key: "drawings", value: false }))
                } catch (error) {
                    if (error.name === 'AbortError') console.error("error from drawings downloading", error);
                } finally {
                    setIsloading(false)
                    // chain download all users 
                    dispatch(updateDownloadTriggered({ key: "allUsers", value: true }))
                }
            })()
        }
    }, [SelectedUser.jwt, SelectedUser.projectNumber, triggered])

    return { isloading }
}